/**
 * Platform detection utilities
 * Determines if the app is running in Electron or web browser
 */

/**
 * Check if the application is running in Electron
 */
export const isElectron = (): boolean => {
  // Method 1: Check user agent
  const userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.indexOf(' electron/') > -1) {
    return true;
  }

  // Method 2: Check if window.electron exists (from preload script)
  if (typeof window !== 'undefined' && window.electron) {
    return true;
  }

  // Method 3: Check process type
  if (typeof window !== 'undefined' && (window as any).process?.type === 'renderer') {
    return true;
  }

  return false;
};

/**
 * Check if the application is running in a web browser
 */
export const isWeb = (): boolean => {
  return !isElectron();
};

/**
 * Platform information
 */
export const platform = {
  isElectron: isElectron(),
  isWeb: isWeb(),
  type: isElectron() ? 'electron' : 'web',
} as const;
